import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/app/[slug]/error.tsx");
